/* BEGIN CUSTOM CODE - Accordion shipping toggle for made-to-order variant updates */
import { ThemeEvents, VariantUpdateEvent } from '@theme/events';
import { morph } from '@theme/morph';

class AccordionShippingToggle {
  /** @param {HTMLElement} element */
  constructor(element) {
    this.element = element;
    const closestSection = element.closest('.shopify-section, dialog');
    this.section = closestSection;
    this.handleVariantUpdate = this.handleVariantUpdate.bind(this);
    closestSection?.addEventListener(ThemeEvents.variantUpdate, this.handleVariantUpdate);
  }

  /**
   * Updates the accordion content when variant changes.
   * @param {VariantUpdateEvent} event
   */
  handleVariantUpdate(event) {
    const newElement = event.detail.data.html.querySelector('accordion-custom[data-shipping-toggle]');

    if (!newElement) return;

    morph(this.element, newElement, { childrenOnly: true });
  }
}

document.querySelectorAll('accordion-custom[data-shipping-toggle]').forEach((el) => {
  new AccordionShippingToggle(el);
});
/* END CUSTOM CODE */
